<template>
  <BlBackdrop title="Create new prospect" :footer="false">
    <div
      class="flex flex-col gap-4 px-8 overflow-y-auto"
      :style="{ width: '40rem', maxHeight: 'calc(100vh - 16rem)' }"
    >
      <BlTextSubtitle1 text="Child's information" />
      <BlInputText :input="nameInput" @changed="inputHandler" />
      <div class="grid grid-cols-2 gap-4">
        <BlInputDate :input="birthdateInput" @changed="inputHandler" />
        <BlSelectBox
          label="Gender"
          v-model="genderInput"
          :placeholder="'Select gender'"
          :options="genderOptions"
          @change="genderInput = $event"
        />
      </div>
      <div class="w-full h-5 bg-grey-100"></div>
      <BlTextSubtitle1 text="Guardian contact information" />
      <div class="grid grid-cols-2 gap-4">
        <BlInputText :input="guardianNameInput" @changed="inputHandler" />
        <BlSelectBox
          label="Relationship type"
          asterisk
          v-model="relationshipTypeInput"
          :placeholder="'Select relationship'"
          :options="relationshipTypeOptions"
          @change="relationshipTypeInput = $event"
        />
      </div>
      <div class="grid grid-cols-2 gap-4">
        <BlInputText
          :input="guardianPhoneNumberInput"
          @changed="inputHandler"
        />
        <!-- <BlInputText :input="guardianEmailInput" @changed="inputHandler" /> -->
      </div>
      <div class="w-full h-5 bg-grey-100"></div>
      <BlTextSubtitle1 text="Additional information" />
      <div class="grid grid-cols-2 gap-4">
        <BlSelectBox
          label="Referral"
          v-model="referralInput"
          :placeholder="'Select referral'"
          :options="referralOptions"
          @change="referralInput = $event"
          search
          drop="up"
        />
        <BlSelectBox
          label="Stage"
          asterisk
          v-model="stageInput"
          :placeholder="'Select stage'"
          :options="stageOptions"
          @change="stageInput = $event"
          search
          disabled
          drop="up"
        />
      </div>
      <BlSelectBox
        v-if="enableBranch"
        type="branch"
        label="Branch"
        placeholder="Select branch"
        v-model="branchInput"
        :options="branchOptions"
        search
        @change="branchInput = $event"
      />
      <BlSearchBox
        label="Prospect's tag"
        v-model="prospectTagsInput"
        placeholder="Select tags"
        :options="prospectTags.map(i => ({ value: i.id, label: i.name }))"
        @change="prospectTagsInput = $event"
        drop="up"
        footer
      >
        <div class="flex gap-2 p-2 rounded-b bg-cornflower-200">
          <BlIcon icon="info" color="cornflower-8" class="w-4 -mt-0.5" />
          <div class="flex items-center gap-1">
            <BlTextBody2
              text="To create or modify tags, please go to "
              class="flex-wrap text-cornflower-800"
            />
            <router-link
              to="/repository?tab=prospect"
              target="_blank"
              class="flex items-center gap-1"
            >
              <BlTextBody2
                text="Center Settings."
                class="flex-wrap font-bold text-cornflower-800"
              />
              <BlIcon icon="square-up" color="cornflower-8" class="w-4 h-4" />
            </router-link>
          </div>
        </div>
      </BlSearchBox>
      <BlSelectBox
        label="Assign to"
        v-model="assignedToInput"
        :placeholder="'Select team member'"
        :options="assignedToOptions"
        @change="assignedToInput = $event"
        search
        drop="up"
      />
    </div>
    <div class="flex items-center justify-between gap-4 px-8 pt-4 pb-8">
      <BlInputButton
        type="plain"
        label="Cancel"
        @clicked="$emit('close-modal')"
      />
      <div class="flex items-center gap-4">
        <BlInputButton
          type="outlined"
          label="Create and add another"
          :disabled="isDisabledSubmit"
          :loading="submitLoading"
          @clicked="onCreate(true)"
        />
        <BlInputButton
          label="Create"
          :disabled="isDisabledSubmit"
          :loading="submitLoading"
          @clicked="onCreate(false)"
        />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputDate from "../../BlInputDate.vue";
import BlSelectBox from "../../BlSelectBox.vue";
import BlSearchBox from "../../BlSearchBox.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "NewProspectModal",
  components: {
    BlBackdrop,
    BlTextSubtitle1,
    BlTextBody2,
    BlIcon,
    BlInputText,
    BlInputDate,
    BlSelectBox,
    BlSearchBox,
    BlInputButton
  },
  props: {},
  data() {
    return {
      submitLoading: false,
      nameInput: {
        label: "Full name",
        asterisk: true,
        placeholder: "Type name",
        model: ""
      },
      birthdateInput: {
        label: "Date of birth",
        model: ""
      },
      genderInput: null,
      genderOptions: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" }
      ],
      guardianNameInput: {
        label: "Full name",
        asterisk: true,
        placeholder: "Type name",
        model: ""
      },
      relationshipTypeInput: null,
      relationshipTypeOptions: [
        { value: "father", label: "Father" },
        { value: "mother", label: "Mother" },
        { value: "other", label: "Other" }
      ],
      guardianPhoneNumberInput: {
        label: "Phone number",
        placeholder: "Type phone number",
        model: ""
      },
      guardianEmailInput: {
        label: "Email",
        placeholder: "Type email",
        model: ""
      },
      referralInput: null,
      referralOptions: [
        { value: "friend_or_family", label: "Friend/family" },
        { value: "outside_provider", label: "Outside provider" },
        { value: "school_or_daycare", label: "School/daycare" },
        { value: "doctor", label: "Doctor" },
        { value: "walk_in", label: "Walk-in" },
        { value: "website", label: "Website" },
        { value: "social_media", label: "Social media" },
        { value: "community_event", label: "Community event" },
        { value: "other", label: "Other" }
      ],
      stageInput: null,
      prospectTagsInput: [],
      prospectTagsOptions: [],
      branchInput: null,
      assignedToInput: null,
      assignedToOptions: []
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "stages", "branches", "prospectTags"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    stageOptions() {
      const arr = this.stages
        .filter(i => !i.is_admitted && !i.is_pending && !i.is_discontinued)
        .sort((a, b) => a.index - b.index)
        .map(i => ({
          value: i.id,
          label: i.name
        }));
      return arr;
    },
    branchOptions() {
      const noBranch = {
        value: null,
        label: "No branch",
        color: "#667085",
        backgroundColor: "#F9FAFB"
      };
      const arr = this.branches.map(i => ({
        value: i.id,
        label: i.name,
        color: i.color,
        backgroundColor: i.background_color
      }));
      return [noBranch, ...arr];
    },
    isDisabledSubmit() {
      if (!this.nameInput.model) return true;
      if (!this.guardianNameInput.model) return true;
      if (!this.relationshipTypeInput) return true;
      if (!this.stageInput) return true;
      return false;
    }
  },
  created() {
    this.getProspectTags({ params: "?sort=name_asc" }); // for get all tags (options)
    this.getUsers({
      search: true,
      params: "?sort=name_asc&status=active&role=admin"
    }).then(({ success, data }) => {
      if (!success) return;
      this.assignedToOptions = data.map(i => ({ value: i.id, label: i.name }));
    });
  },
  async mounted() {
    if (this.stages[0]) {
      this.stageInput = this.stages[0].id;
    }
  },
  methods: {
    ...mapActions(["getUsers", "getProspectTags", "createProspect"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    resetInput() {
      this.nameInput.model = "";
      this.birthdateInput.model = "";
      this.genderInput = null;
      this.guardianNameInput.model = "";
      this.relationshipTypeInput = null;
      this.guardianPhoneNumberInput.model = "";
      this.guardianEmailInput.model = "";
      this.referralInput = null;
      if (this.stages[0]) {
        this.stageInput = this.stages[0].id;
      } else {
        this.stageInput = null;
      }
      this.branchInput = null;
      this.prospectTagsInput = [];
      this.assignedToInput = null;
    },
    onCreate(again = false) {
      const data = {
        prospect: {
          name: this.nameInput.model,
          birthdate: this.birthdateInput.model,
          gender: this.genderInput,
          guardian_name: this.guardianNameInput.model,
          guardian_relationship_type: this.relationshipTypeInput,
          guardian_phone_number: this.guardianPhoneNumberInput.model,
          // guardian_email: this.guardianEmailInput.model,
          referral: this.referralInput,
          stage_id: this.stageInput,
          branch_id: this.branchInput,
          prospect_tag_ids: this.prospectTagsInput,
          assigned_user_id: this.assignedToInput
        }
      };
      this.submitLoading = true;
      this.createProspect(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.$emit("after-commit", this.stageInput);
        if (again) this.resetInput();
        else this.$emit("close-modal");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/modal/NewProspectModal.vue